/* eslint-disable @typescript-eslint/no-namespace */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RpcClient } from '../rpc-socket/rpcClient'

export namespace ExportApi {
	export type TExportListArrayElem = {
		templateID: string
		templateName: string
		devices: Array<{
			tag: string
			name: string
		}>
		encoding: Array<string>
		datePicker: boolean
	}
	export type TExportListArray = Array<TExportListArrayElem>

	export type TExportList = {
		exportList: {
			[key: string]: TExportListArray
		}
		dateRange: [number, number] // минимально и максимально допустимые значения времени
	}

	export const getExportList = createAsyncThunk(
		'export/getExportList',
		async () => {
			return RpcClient.call('getExportList', {})
		}
	)
	export type TEnumControl =
		| 'input'
		| 'checkbox'
		| 'listbox'
		| 'group'
		| 'radio-group'
	export type TExportSort = 'null' | 'asc' | 'desc'

	export type TExtraSettingsElemList = {
		name: string
		caption: string
		type: string
		value: number
	}

	export type TExtraSettingsElemValues = {
		name: string
		caption: string
	}
	export type TExtraSettingsElem = {
		name: string
		caption: string
		type: string
		value: number
		selectedIndex?: number
		options: {
			validation?: {
				type: string
			}
			disabled?: boolean
		}
		values?: Array<string> | Array<TExtraSettingsElemValues>
		list?: Array<TExtraSettingsElemList>
	}
	export type TGetExportSettingsResponse = {
		fieldSettings: Array<{
			key: string
			caption: string
			show: boolean
			sort: TExportSort
		}>
		extraSettings: Array<TExtraSettingsElem>
		save: boolean // Сохранять настройки
	}
	export const getExportSettings = createAsyncThunk(
		'export/getExportSettings',
		async (templateID: number) => {
			return RpcClient.call('getExportSettings', { templateID: templateID })
		}
	)
	export type TCountersEnum =
		| 'counter_coldwater'
		| 'counter_hotwater'
		| 'counter_wastewater'
		| 'counter_gas'
		| 'counter_energy'
		| 'counter_heat'
	export type TListIdEnum = 'all' | 'selected' | 'userId'

	export type TExportTypeEnum =
		| 'current'
		| 'history'
		| 'change'
		| 'by_hour'
		| 'power_profiles'
		| 'tech_energy'
		| 'tech_heat'
		| 'tech_c2000_r'
		| 'tech_c2000_vti_current'
		| 'tech_c2000_vti_history'

	export type TGetExportFileUrlRequest = {
		objectId: Array<string>
		exportType: TExportTypeEnum
		templateID: number
		encodingID: number
		date: number | Array<number>
		counters: Array<TCountersEnum>
		listId: TListIdEnum
		settings?: any
	}

	export type TGetExportFileUrlResponse = {
		objectId: Array<string>
		url: string
	}
	export const getExportFileUrl = (request: TGetExportFileUrlRequest) => {
		return RpcClient.call('getExportFileUrl', request)
	}
}
